module.exports = __webpack_public_path__ + "img/find-gadget.35f991dc.png";